var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.social.link,"target":"_blank"}},[_c('img',{attrs:{"src":require(`@/assets/img/${_vm.$chain.getName()}/footer/social/ic-${_vm.social.icon}.svg`),"alt":_vm.social.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }